export const SET_COMICS = 'SET_COMICS'
export const SET_CHAPTER = 'SET_CHAPTER'
export const SET_PARAM = 'SET_PARAM'
export const SET_USER = 'SET_USER'
export const SET_ISSHOW = 'SET_ISSHOW'
export const SET_POSTLIST = 'SET_POSTLIST'
export const SET_CURRENTPAGE = 'SET_CURRENTPAGE'
export const SET_COUNT = 'SET_COUNT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js